module.exports = __webpack_public_path__ + "img/hero-01-1.a924a97b.jpg";